import { CompositionChildEditPreviewDto } from '@app/modules/compose/composition.types';

import { getCompositionEditThumbnailSrc } from './get-composition-edit-thumbnail-src';

/**
 * Default main-preview edit index for a composition card: last edit (API order)
 * that has a thumbnail URL, or the last edit when none do.
 */
export function getCompositionListDefaultPreviewEditIndex(
  edits: CompositionChildEditPreviewDto[],
): number {
  if (edits.length === 0) {
    return -1;
  }
  for (let i = edits.length - 1; i >= 0; i -= 1) {
    if (getCompositionEditThumbnailSrc(edits[i]) != null) {
      return i;
    }
  }
  return edits.length - 1;
}
